var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 30.995H14.5842C15.6505 30.995 16.5149 30.1306 16.5149 29.0643V23.2722M16.5149 23.2722H33.8911C34.9574 23.2722 35.8218 22.4078 35.8218 21.3415V17.4801C35.8218 16.4138 34.9574 15.5494 33.8911 15.5494H24.2376M16.5149 23.2722H3M24.2376 15.5494V9.75735C24.2376 8.69106 23.3732 7.82666 22.3069 7.82666H3M24.2376 15.5494H3",
    stroke: "#8A96A3",
    strokeWidth: 3.5396
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3V35.5",
    stroke: "#8A96A3",
    strokeWidth: 3.5396,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPoll);
export default __webpack_public_path__ + "static/media/add_poll.72877a12c68adf74a3778fc08c775ca6.svg";
export { ForwardRef as ReactComponent };